module.exports = __webpack_public_path__ + "images/internal/review_widgets/theme/custom_icon.svg";